import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: '#0A1628', color: '#B5D4F4', padding: '56px 0 32px' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 40, marginBottom: 48 }}>
          {/* Brand */}
          <div>
            <p style={{ color: '#fff', fontWeight: 600, marginBottom: 8 }}>Sagient Partners</p>
            <p style={{ color: '#8BAFC8', fontSize: '0.9rem', lineHeight: 1.7 }}>
              Helping businesses operationalize AI - strategically and practically.
            </p>
          </div>

          {/* Links */}
          <div>
            <p style={{ color: '#fff', fontWeight: 600, marginBottom: 16 }}>Company</p>
            {[['/', 'Home'], ['/services', 'Services'], ['/about', 'About']].map(([to, label]) => (
              <Link key={to} to={to} style={{ display: 'block', color: '#8BAFC8', marginBottom: 10, fontSize: '0.9rem', transition: '0.15s' }}
                onMouseOver={e => e.target.style.color = '#B5D4F4'}
                onMouseOut={e => e.target.style.color = '#8BAFC8'}
              >{label}</Link>
            ))}
            <a href="/blog" style={{ display: 'block', color: '#8BAFC8', marginBottom: 10, fontSize: '0.9rem', transition: '0.15s' }}
              onMouseOver={e => e.target.style.color = '#B5D4F4'}
              onMouseOut={e => e.target.style.color = '#8BAFC8'}
            >Blog</a>
            <Link to="/contact" style={{ display: 'block', color: '#8BAFC8', marginBottom: 10, fontSize: '0.9rem', transition: '0.15s' }}
              onMouseOver={e => e.target.style.color = '#B5D4F4'}
              onMouseOut={e => e.target.style.color = '#8BAFC8'}
            >Contact</Link>
          </div>

          {/* Services */}
          <div>
            <p style={{ color: '#fff', fontWeight: 600, marginBottom: 16 }}>Services</p>
            {[
              ['AI Readiness Assessment', '/services/ai-readiness-assessment'],
              ['AI Strategy Implementation', '/services/ai-strategy-implementation'],
              ['AI Advisor', '/services/ai-advisor'],
            ].map(([s, to]) => (
              <Link key={s} to={to} style={{ display: 'block', color: '#8BAFC8', marginBottom: 10, fontSize: '0.9rem' }}>{s}</Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <p style={{ color: '#fff', fontWeight: 600, marginBottom: 16 }}>Get in Touch</p>
            <a href="mailto:info@sagientpartners.com" style={{ display: 'block', color: '#378ADD', marginBottom: 10, fontSize: '0.9rem' }}>
              info@sagientpartners.com
            </a>
            <p style={{ color: '#8BAFC8', fontSize: '0.9rem' }}>San Francisco Bay Area</p>
            <Link to="/contact" className="btn btn-outline" style={{ marginTop: 20, borderColor: '#378ADD', color: '#378ADD', padding: '10px 20px', fontSize: '0.88rem' }}>
              Book a Discovery Call
            </Link>
          </div>
        </div>

        <div style={{ borderTop: '1px solid #1E3A5F', paddingTop: 24, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ color: '#4A6FA0', fontSize: '0.85rem' }}>© {new Date().getFullYear()} Sagient Partners. All rights reserved.</p>
          <div style={{ display: 'flex', gap: 24 }}>
            <Link to="/privacy" style={{ color: '#4A6FA0', fontSize: '0.85rem' }}>Privacy Policy</Link>
            <p style={{ color: '#4A6FA0', fontSize: '0.85rem' }}>sagientpartners.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
